<template>
	<div class="section">
		<div class="container">
			<h1>Terms and Conditions agreement</h1>
			<br />
			<b-field><b-checkbox v-model="agreed">I agree to the terms and conditions listed below.</b-checkbox></b-field>
			<b-field><b-button class="is-primary" @click="agree">Submit</b-button></b-field>
			<br />
			<div class="columns">
				<div class="column">
					<pdf v-for="i in 6"
						 :key="i"
						 src="AWG Carbon Calculator -- Terms of Use.pdf"
						 :page="i"></pdf>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import pdf from 'vue-pdf';
	export default {
		components: {
			pdf
		},
		data() {
			return {
				agreed: false
			}
		},
		methods: {
			agree() {
				this.$http.get("api/authentication/agree")
					.then(resp => {
						if (resp.data == true) {
							this.$store.dispatch('setAgreed')
								.then(resp => {
									this.$router.push('/aircraft');
								})
						} else {
							this.$buefy.toast.open({
								message: "Failed to agree to terms and conditions.",
								type: 'is-danger'
							})
						}
					})
			}
		}
	}
</script>
